import { ElNotification } from "element-plus";
import { getApiErrorMessage } from "@/utils/apiResponseHandler";
import { AxiosError } from "axios";

/* eslint-disable no-console */
export function errorHandler(error: AxiosError) {
  if (error.response) {
    // Log detailed error in the console for developers
    console.error("Error Response Data:", error.response.data);
    console.error("Error Status:", error.response.status);
    console.error("Error Headers:", error.response.headers);

    // Show user-friendly notification in Dutch
    const errorMessage = getApiErrorMessage(error);
    ElNotification({
      title: "Fout",
      message: `De server reageerde met een fout: ${error.response.status} - ${errorMessage}. Foutcode: ${error.response.status}`,
      type: "error",
    });
  } else if (error.request) {
    // Log the request error for developers
    console.error("Error Request:", error.request);

    // Show user-friendly notification in Dutch
    ElNotification({
      title: "Netwerkfout",
      message:
        "Geen antwoord ontvangen van de server. Controleer uw netwerkverbinding.",
      type: "error",
    });
  } else {
    // Log generic error for developers
    console.error("Request Setup Error:", error.message);

    // Show user-friendly notification in Dutch
    ElNotification({
      title: "Verzoekfout",
      message: `Fout bij het instellen van het verzoek: ${error.message}`,
      type: "error",
    });
  }
}
